import { createApp } from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';

import MapRegion from '../../../vue-components/pages/programs/MapRegion';
import StepsSlider from '../../../vue-components/pages/StepsSwitcher';
import FormQuestionPrograms from '../../../vue-components/FormQuestionPrograms';
import DocsForBusiness from '../../../vue-components/pages/programs/DocsForBusiness';
import CreditorTable from '../../../vue-components/pages/programs/CreditorTable';
import NewsBlock from '../../../vue-components/pages/programs/NewsBlock';
import anchorLinks from '../../../modules/anchor-links';

document.addEventListener('DOMContentLoaded', () => {
    // vueAppInitiator(vueApps);

    // родительскиq компоненты vue.js
    const programsPageEl = document.getElementById('programs-fb-page');

    createApp({
        components: {
            MapRegion,
            StepsSlider,
            FormQuestionPrograms,
            DocsForBusiness,
            CreditorTable,
            NewsBlock
        },
        data() {
            return {
                showLimitTable: false
            };
        },
        methods: {
            showTable(param) {
                console.log('param', param);
                if (param === '4497') {
                    this.showLimitTable = true;
                } else {
                    this.showLimitTable = false;
                }
            }
        }
    }).use(VueAxios, axios).mount(programsPageEl);

    // programsMapInit();
    anchorLinks();
});
